import React from 'react';
import SearchTitleForm from './SearchTitleForm'
import SearchButton from './SearchButton'
import SearchDateAndTime from './SearchDateAndTime'
import SearchCountryForm from './SearchCountry'
import SearchProvinceForm from './SearchProvince'
import SearchCityForm from './SearchCity'
import SearchProductSystemForm from './SearchProductSystem'
import SearchProductForm from './SearchProduct'
import SearchZipForm from './SearchZipForm'
import SearchFOEForm from './SearchFOE'
import SearchCreator from './SearchCreator'
import SearchFirmForm from './SearchFirm';
import SearchCreateDateAndTime from './SearchCreateDateAndTime'
import SearchCreateDateAndTimeTill from './SearchCreateDateAndTimeTill'
import SearchContestRelease from './SearchContestRelease'
import checkToken from '../../Token/checkToken'
import Menu from '../MenuBar';

export default class SearchRef extends React.Component {

    render() {

        return(
            <div className='searchRefClassFull'>
            { checkToken() ? 
            <div>

            <Menu />
                <div className='createRefClass'>
                <SearchTitleForm/>
                <SearchFirmForm/>
                <SearchCountryForm/>
                <SearchProvinceForm/>
                <SearchCityForm/>
                <SearchZipForm/>
                <SearchProductForm/>
                <SearchProductSystemForm/>
                <SearchFOEForm/>
                <SearchCreator/>
                <SearchDateAndTime/>
                {parseInt(localStorage.getItem('role_id')) === 1 ?
                (<div>
                    <SearchCreateDateAndTime/>
                    <SearchCreateDateAndTimeTill/>
                </div>)
                 : ''
                }
                <SearchContestRelease />
                <SearchButton/>
                </div>
            </div>

            :  window.location.reload()} </div>

        )
    }   

}